// extracted by mini-css-extract-plugin
export default {"container":"container__2fNeV","btn":"btn__85AN9","video":"video__+mtNz","canvas":"canvas__MKpVF"};